/**
 * Page-level background and layout styles.
 */
import * as stylex from "@stylexjs/stylex";

import { colors, space } from "../tokens.stylex";

const styles = stylex.create({
  dark: {
    backgroundColor: colors.backgroundSubtle,
    color: colors.foreground,
  },
  padding: {
    padding: space.md,
  },
});

// Export styles for direct use with stylex.props()
export const page = styles;
